<template>
    <div class="w-100 pb-5">
        <div class="py-4">
            <h4>All Clients' Goals</h4>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="row mx-0 px-2" style="background-color: #323336">
                    <div class="col-1 px-1"></div>
                    <div class="col-3 px-1">
                        <small class="text-uppercase text-white">Patient Name</small>
                    </div>
                    <div class="col-2 px-1">
                        <small class="text-uppercase text-white">City</small>
                    </div>
                    <div class="col-3 px-1">
                        <small class="text-uppercase text-white">Supervisor</small>
                    </div>
                    <div class="col-3 px-1">
                        <small class="text-uppercase text-white">Services Receiving</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mx-0 bg-white">
            <div class="col-12">
                <div v-for="p in patients" class="row p-2 list-item" :class="">
                    <div class="px-1 col-1">
                        <img
                            class="img-fluid rounded-circle mr-2 profile-image"
                            :src="
                                p.profile_photo_url
                                    ? p.profile_photo_url
                                    : '../../../images/default_patient.jpeg'
                            "
                        />
                    </div>
                    <div class="px-1 col-3 d-flex align-items-center">
                        <a
                            class="text-primary cursor-pointer"
                            :href="`/patients/${p.id}/goals`"
                            data-private="lipsum"
                            >{{ p.name }}</a
                        >
                    </div>
                    <div class="px-1 col-2 d-flex align-items-center">
                        <span>{{ `City` }}</span>
                    </div>
                    <div class="px-1 col-3 d-flex align-items-center">
                        <span>{{ `Supervisor` }}</span>
                    </div>
                    <div class="px-1 col-3 d-flex align-items-center">
                        <span>{{ `Service` }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GoalsExportExcel from "./GoalsExportExcel";
import GoalsExportSoap from "./GoalsExportSoap";
import GoalsAverageScore from "./GoalsAverageScore";
import GoalsSummary from "./GoalsSummary";
import GoalsNew from "./GoalsNew";
import GoalsStatusFilter from "./GoalsStatusFilter";
import GoalsDomainFilter from "./GoalsDomainFilter";

export default {
    name: "AllGoalsOverview",
    props: [
        "goals",
        "goalsAverageScore",
        "goal",
        "patient",
        "domains",
        "organizationId",
        "userId",
        "patients",
    ],
    components: {
        GoalsSummary,
        GoalsStatusFilter,
        GoalsDomainFilter,
    },
    data() {
        return {
            therapists: [{ id: 1, name: "Amy Lee" }, { id: 2, name: "Laura Foster" }],
            actionsOpen: false,
            collapsed: false,
            tracking: 0,
            showExport: false,
            goalStatusFilter: 0,
            goalDomainFilter: 0,
        };
    },
    methods: {
        openNewGoal(event) {
            // TODO: refresh goals prop
            this.$emit("refresh-goals");
            this.setParentProp("goal", event);
        },
        refreshGoals() {
            this.$emit("refresh-goals");
        },
    },
};
</script>

<style scoped lang="scss">
.profile-image {
    min-width: 3rem;
    max-width: 3rem;
    min-height: 3rem;
    max-height: 3rem;
}
.list-item {
    border: solid 1px #bfbfbf;
}
.list-item:not(:first-child) {
    border-top: none;
}
</style>
